// pagination_method.ts
import axios from "axios";
import { numberData } from "./numberData";
import config from "../../config";
import { headers_get } from "../tokens/get_headers_user";

type QueryParams = Record<string, any> | null;

interface UrlMapping {
  url: string;
  urlnumber?: string;
  urlenablePagination?: string;
}

// Si sabes qué estructura regresan los endpoints, reemplaza `unknown` por tu tipo (p.ej. `Invoice`, `Cabinet`, etc.)
export async function pagination_method_ts<T = unknown>(
  origen: string,
  params: QueryParams,
  enablePagination: boolean = true
): Promise<T[]> {
  const headers: Record<string, string> = await headers_get();

  const URL_MAPPINGS: Record<string, UrlMapping> = {
    bp: {
      url: `${config?.URL_BUSINESS_PARTNERS}/od/business-partners?role=FACTURA&`,
      urlnumber: `${config?.URL_BUSINESS_PARTNERS}/od/business-partners/number`,
    },

    invoices: {
      url: `${config?.URL_INVOICES}/od/invoices?count=false&`,
      urlenablePagination: `${config?.URL_INVOICES}/od/invoices?count=false`,
      urlnumber: `${config?.URL_INVOICES}/od/invoices?count=true`,
    },
  };

  const {
    url = String(config?.URL_BUSINESS_PARTNERS ?? ""),
    urlnumber = "",
    urlenablePagination = "",
  } = URL_MAPPINGS[origen] || {};

  if (enablePagination) {
    try {

      
      // numberData debería devolver un número total de registros
      const totalData: number | undefined = await numberData(urlnumber, params);
      if (!totalData) return [];

      if (totalData <= 1000) {
        const { data } = await axios.get<T[]>(
          `${url}offset=0&limit=${totalData}`,
          { params, headers }
        );
        return data ?? [];
      }

      const pageSize = 1000;
      const numRequests = Math.ceil(totalData / pageSize);

      const baseIncrement = Math.ceil(totalData / numRequests); // incremento base del offset/limit
      let offset = 0;
      const promises: Promise<T[]>[] = [];

      for (let i = 0; i < numRequests; i++) {
        const limit = baseIncrement * (i + 1); // límite acumulativo
        const requestUrl = `${url}offset=${offset}&limit=${limit}`;
        const p = axios
          .get<T[]>(requestUrl, { params, headers })
          .then((response) => response.data ?? []);
        promises.push(p);
        offset += baseIncrement;
      }

      const results = await Promise.all(promises);
      return results.flat();
    } catch (error) {
      console.error("Error in pagination_method:", error);
      return [];
    }
  } else {
    try {
      const { data } = await axios.get<T[]>(`${urlenablePagination}`, {
        params,
        headers,
      });
      return data ?? [];
    } catch (error) {
      console.error("Error in pagination_method:", error);
      return [];
    }
  }
}
